import React from 'react';
import { Container } from '@mui/material';
import Header from '../components/layout/Header';
import HeroSection from '../components/sections/HeroSection';
import ServicesSection from '../components/sections/ServicesSection';

const Home = () => {
  return (
    <>
      <Header />
      <Container maxWidth="xl" sx={{ mt: { xs: 2, md: 4 }, px: { xs: 2, sm: 3 } }}>
        <HeroSection />
        <ServicesSection />
      </Container>
    </>
  );
};

export default Home;